import { useOne, useShow } from '@refinedev/core';
import { Show } from '@refinedev/antd';
import { Space, theme } from 'antd';
import type { PublicationListOut, ReviewOut } from '@/api/generated/schemas';
import { bareShowContentProps } from '@/components/common/show/shared';
import { useShowTab } from '@/components/common/show/useShowTab';
import { ReviewActionButtons } from '@/components/feedback/ReviewActionButtons';
import { useRecordDocumentTitle } from '@/hooks/useRecordDocumentTitle';
import { REVIEW_DEFAULT_TAB, REVIEW_SHOW_TABS } from '../constants';
import { ReviewShowHeader } from './ReviewShowHeader';
import { ReviewGeneralTab } from './ReviewGeneralTab';

export const ReviewShow = () => {
  const { token } = theme.useToken();
  const { query } = useShow<ReviewOut>({
    resource: 'feedback.reviews',
  });
  const { data, isLoading } = query;
  const record = data?.data;

  useRecordDocumentTitle('feedback.reviews', record?.author_name);

  const [activeTab, onTabChange] = useShowTab(
    REVIEW_SHOW_TABS,
    REVIEW_DEFAULT_TAB
  );

  const { result: publication } = useOne<PublicationListOut>({
    resource: 'user_catalog.publications',
    id: record?.publication_id ?? 0,
    queryOptions: { enabled: !!record?.publication_id },
  });

  return (
    <Show
      isLoading={isLoading}
      contentProps={bareShowContentProps}
      headerButtons={({ defaultButtons }) => (
        <Space>
          {defaultButtons}
          {record?.id && (
            <ReviewActionButtons
              reviewId={record.id}
              isAccepted={record.is_accepted}
              isRejected={record.is_rejected}
            />
          )}
        </Space>
      )}
    >
      {record && (
        <>
          <ReviewShowHeader
            record={record}
            publication={publication}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
          <div style={{ marginTop: token.margin }}>
            {activeTab === 'general' && (
              <ReviewGeneralTab record={record} publication={publication} />
            )}
          </div>
        </>
      )}
    </Show>
  );
};
